<div id="name-change" fxLayout="column" fxLayoutAlign="center center">
  <div class="content" fxLayout="row wrap">
    @if (!isNameUpdated) {
      <div
        fxLayout="column"
        fxFlex="50"
        fxFlex.md="50"
        fxFlex.sm="100"
        fxFlex.xs="100"
        fxLayout="column">
        @if (canChangeName) {
          <mat-card class="nameupdate-card">
            <h2>{{ 'USERS.NAMECHANGE.TITLE' | translate }}</h2>
            <div class="normal-box">
              {{ 'USERS.NAMECHANGE.DESCRIPTION1' | translate }}
            </div>
            <div class="bold-text message-box warning">
              {{ 'USERS.NAMECHANGE.DESCRIPTION2' | translate }}
            </div>
            <br />
            <mat-list role="list">
              <mat-list-item>
                <mat-icon matListItemIcon>warning</mat-icon>
                <h4 matListItemTitle class="nobreak">
                  {{ 'USERS.NAMECHANGE.TOOLTIP.FIRSTNAME' | translate }}
                </h4>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>warning</mat-icon>
                <h4 matListItemTitle class="nobreak">
                  {{ 'USERS.NAMECHANGE.TOOLTIP.LASTNAME' | translate }}
                </h4>
              </mat-list-item>
            </mat-list>
            <span> {{ 'USERS.NAMECHANGE.SENDINFO' | translate }}</span>
            @if (isErrorUpdateName) {
              <div class="general-container">
                <div class="message-box error">
                  <app-error-message [error]="errorUpdateName.error" />
                </div>
              </div>
            }
            @if (isNameUpdated) {
              <div class="general-container">
                <div class="message-box success">
                  {{ 'NAMEUPDATE.FORM.SUCCESS' | translate }}
                  {{ userAccountname }}
                </div>
              </div>
            }
          </mat-card>
        }
        @if (canChangeNameStd) {
          <mat-card class="nameupdate-card">
            <h2>{{ 'USERS.NAMECHANGE.STUDENT.TITLE' | translate }}</h2>
            <div class="normal-box">
              {{ 'USERS.NAMECHANGE.DESCRIPTION1' | translate }}
            </div>
            <div class="bold-text message-box warning">
              {{ 'USERS.NAMECHANGE.DESCRIPTION2' | translate }}
            </div>
            <mat-list role="list">
              <mat-list-item>
                <mat-icon matListItemIcon>warning</mat-icon>
                <h4 matListItemTitle class="nobreak">
                  {{ 'USERS.NAMECHANGE.STUDENT.TOOLTIP.FIRSTNAME' | translate }}
                </h4>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>warning</mat-icon>
                <h4 matListItemTitle class="nobreak">
                  {{ 'USERS.NAMECHANGE.STUDENT.TOOLTIP.LASTNAME' | translate }}
                </h4>
              </mat-list-item>
            </mat-list>
            <div class="normal-box">
              {{ 'USERS.NAMECHANGE.STUDENT.UPDATE' | translate }}
            </div>
            @if (isErrorUpdateName) {
              <div class="general-container">
                <div class="message-box error">
                  <app-error-message [error]="errorUpdateName.error" />
                </div>
              </div>
            }
            @if (isNameUpdated) {
              <div class="general-container">
                <div class="message-box success">
                  {{ 'NAMEUPDATE.FORM.SUCCESS' | translate }}
                  {{ userAccountname }}
                </div>
              </div>
            }
          </mat-card>
        }
      </div>
    }
    @if (!isNameUpdated) {
      <div
        fxLayout="column"
        fxFlex="50"
        fxFlex.md="50"
        fxFlex.sm="100"
        fxFlex.xs="100"
        fxLayout="column">
        @if (canChangeName) {
          <mat-card class="nameupdate-card">
            <h2>{{ 'USERS.NAMECHANGE.TITLE' | translate }}</h2>
            <form
              fxLayout="column"
              class="form-updatename"
              [formGroup]="changenameForm">
              <div fxFlex="1 0 auto" fxLayout="column">
                <div fxFlex="2 0 auto" fxLayout="row">
                  <mat-form-field fxFlex="100" appearance="outline">
                    <mat-label>{{
                      'USERS.SINGLE.INFO.OFFICIALFIRSTNAME' | translate
                    }}</mat-label>
                    <input
                      autoComplete="on"
                      matInput
                      formControlName="officialFirstName" />
                  </mat-form-field>
                </div>
                <div fxFlex="2 0 auto" fxLayout="row">
                  <mat-form-field fxFlex="100" appearance="outline">
                    <mat-label>{{
                      'USERS.SINGLE.INFO.OFFICIALLASTNAME' | translate
                    }}</mat-label>
                    <input
                      autoComplete="on"
                      matInput
                      formControlName="officialLastName" />
                  </mat-form-field>
                </div>
                <div fxFlex="2 0 auto" fxLayout="row">
                  <mat-form-field fxFlex="100" appearance="outline" required>
                    <mat-label>{{
                      'USERS.SINGLE.INFO.USUALFIRSTNAME' | translate
                    }}</mat-label>
                    <input
                      autoComplete="on"
                      matInput
                      formControlName="firstName"
                      (input)="updateUserLoginForm()"
                      required />
                    @if (hasMultipleFirstName) {
                      <mat-icon
                        matSuffix
                        class="mat-icon-custom"
                        matTooltip="{{
                          'GENERAL.TOOLTIP.FIRSTNAME' | translate
                        }}">
                        help
                      </mat-icon>
                    }
                    <mat-error class="error-password">{{
                      'ERROR.FIRSTNAME' | translate
                    }}</mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="2 0 auto" fxLayout="row">
                  <mat-form-field fxFlex="100" appearance="outline" required>
                    <mat-label>{{
                      'USERS.SINGLE.INFO.USUALLASTNAME' | translate
                    }}</mat-label>
                    <input
                      autoComplete="on"
                      matInput
                      formControlName="lastName"
                      (input)="updateUserLoginForm()"
                      required />
                    @if (hasMultipleLastName) {
                      <mat-icon
                        matSuffix
                        class="mat-icon-custom"
                        matTooltip="{{
                          'GENERAL.TOOLTIP.LASTNAME' | translate
                        }}">
                        help
                      </mat-icon>
                    }
                    <mat-error>{{ 'ERROR.LASTNAME' | translate }}</mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="2 0 auto" fxLayout="row">
                  <mat-form-field fxFlex="100" appearance="outline">
                    <mat-label>{{ 'USER.EMAIL' | translate }}</mat-label>
                    <input
                      autoComplete="on"
                      matInput
                      formControlName="eduvsMail" />
                    <mat-icon
                      matSuffix
                      class="mat-icon-custom"
                      matTooltip="{{ 'USER.MY-EMAIL-TOOLTIP' | translate }}">
                      help
                    </mat-icon>
                  </mat-form-field>
                </div>
                <div fxFlex="2 0 auto" fxLayout="row">
                  <mat-form-field fxFlex="100" appearance="outline">
                    <mat-label>{{ 'USER.LOGIN' | translate }}</mat-label>
                    <input
                      autoComplete="on"
                      matInput
                      formControlName="eduvsLogin" />
                    <mat-icon
                      matSuffix
                      class="mat-icon-custom"
                      matTooltip="{{ 'USER.MY-LOGIN-TOOLTIP' | translate }}">
                      help
                    </mat-icon>
                  </mat-form-field>
                </div>
                <div
                  class="general-container"
                  fxLayout="row"
                  fxLayoutAlign="left center">
                  <button
                    mat-raised-button
                    matStepperNext
                    type="button"
                    color="accent"
                    (click)="changeName()"
                    [disabled]="
                      changenameForm.invalid || isNameUpdated || isBusy
                    ">
                    {{ 'GENERAL.SAVE' | translate }}
                  </button>
                  <div class="logout-user">
                    <button
                      class="logout"
                      mat-raised-button
                      color="warn"
                      (click)="logout()">
                      <mat-icon class="logout-icon">exit_to_app</mat-icon>
                      <span>Logout</span>
                    </button>
                  </div>
                </div>
              </div>
              @if (isBusyUpdateName) {
                <div
                  class="general-container"
                  fxLayout="row"
                  fxLayoutAlign="center center">
                  <mat-progress-spinner
                    [color]="spinner.color"
                    [mode]="spinner.mode"
                    [value]="spinner.value"
                    [diameter]="spinner.diameter">
                  </mat-progress-spinner>
                </div>
              }
            </form>
          </mat-card>
        }
        @if (canChangeNameStd) {
          <mat-card class="nameupdate-card">
            <h2>{{ 'USERS.NAMECHANGE.STUDENT.TITLE' | translate }}</h2>
            <form
              fxLayout="column"
              class="form-updatename"
              [formGroup]="changenameForm">
              <div fxFlex="1 0 auto" fxLayout="column">
                <div fxFlex="2 0 auto" fxLayout="row">
                  <mat-form-field fxFlex="100" appearance="outline">
                    <mat-label>{{
                      'USERS.SINGLE.INFO.OFFICIALFIRSTNAME' | translate
                    }}</mat-label>
                    <input
                      autoComplete="on"
                      matInput
                      formControlName="officialFirstName" />
                  </mat-form-field>
                </div>
                <div fxFlex="2 0 auto" fxLayout="row">
                  <mat-form-field fxFlex="100" appearance="outline">
                    <mat-label>{{
                      'USERS.SINGLE.INFO.OFFICIALLASTNAME' | translate
                    }}</mat-label>
                    <input
                      autoComplete="on"
                      matInput
                      formControlName="officialLastName" />
                  </mat-form-field>
                </div>
                <div fxFlex="2 0 auto" fxLayout="row">
                  <mat-form-field fxFlex="100" appearance="outline" required>
                    <mat-label>{{
                      'USERS.SINGLE.INFO.USUALFIRSTNAME' | translate
                    }}</mat-label>
                    <input
                      autoComplete="on"
                      matInput
                      formControlName="firstName"
                      required />
                    @if (hasMultipleFirstName) {
                      <mat-icon
                        matSuffix
                        class="mat-icon-custom"
                        matTooltip="{{
                          'GENERAL.TOOLTIP.FIRSTNAME' | translate
                        }}">
                        help
                      </mat-icon>
                    }
                    <mat-error class="error-password">{{
                      'ERROR.FIRSTNAME' | translate
                    }}</mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="2 0 auto" fxLayout="row">
                  <mat-form-field fxFlex="100" appearance="outline" required>
                    <mat-label>{{
                      'USERS.SINGLE.INFO.USUALLASTNAME' | translate
                    }}</mat-label>
                    <input
                      autoComplete="on"
                      matInput
                      formControlName="lastName"
                      required />
                    @if (hasMultipleLastName) {
                      <mat-icon
                        matSuffix
                        class="mat-icon-custom"
                        matTooltip="{{
                          'GENERAL.TOOLTIP.LASTNAME' | translate
                        }}">
                        help
                      </mat-icon>
                    }
                    <mat-error>{{ 'ERROR.LASTNAME' | translate }}</mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="2 0 auto" fxLayout="row">
                  <mat-form-field fxFlex="100" appearance="outline">
                    <mat-label>{{ 'USER.EMAIL' | translate }}</mat-label>
                    <input
                      autoComplete="on"
                      matInput
                      formControlName="eduvsMail" />
                    <mat-icon
                      matSuffix
                      class="mat-icon-custom"
                      matTooltip="{{ 'USER.MY-EMAIL-TOOLTIP' | translate }}">
                      help
                    </mat-icon>
                  </mat-form-field>
                </div>
                <div fxFlex="2 0 auto" fxLayout="row">
                  <mat-form-field fxFlex="100" appearance="outline">
                    <mat-label>{{ 'USER.LOGIN' | translate }}</mat-label>
                    <input
                      autoComplete="on"
                      matInput
                      formControlName="eduvsLogin" />
                    <mat-icon
                      matSuffix
                      class="mat-icon-custom"
                      matTooltip="{{ 'USER.MY-LOGIN-TOOLTIP' | translate }}">
                      help
                    </mat-icon>
                  </mat-form-field>
                </div>
                <mat-checkbox
                  [formControl]="changenameForm.get('hasValidate') | formPipe">
                  {{ 'USERS.UPDATE-CONFIRM' | translate }}</mat-checkbox
                >
                @if (isBusyUpdateName) {
                  <div
                    class="general-container"
                    fxLayout="row"
                    fxLayoutAlign="center center">
                    <mat-progress-spinner
                      [color]="spinner.color"
                      [mode]="spinner.mode"
                      [value]="spinner.value"
                      [diameter]="spinner.diameter">
                    </mat-progress-spinner>
                  </div>
                }
                <div
                  class="general-container"
                  fxLayout="row"
                  fxLayoutAlign="left center">
                  <button
                    mat-raised-button
                    matStepperNext
                    type="button"
                    color="accent"
                    (click)="changeName()"
                    [disabled]="
                      changenameForm.invalid ||
                      isNameUpdated ||
                      isBusy ||
                      !changenameForm.get('hasValidate').value
                    ">
                    {{ 'GENERAL.SAVE' | translate }}
                  </button>
                  <div class="logout-user">
                    <button
                      class="logout"
                      mat-raised-button
                      color="warn"
                      (click)="logout()">
                      <mat-icon class="logout-icon">exit_to_app</mat-icon>
                      <span>Logout</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </mat-card>
        }
      </div>
    }
    @if (isNameUpdated) {
      <div class="content" fxLayout="row wrap" fxFill>
        <div
          fxLayout="column"
          fxFlex="100"
          fxFlex.md="100"
          fxFlex.sm="100"
          fxFlex.xs="100"
          fxLayout="column">
          @if (canChangeName) {
            <mat-card class="security-card">
              <h2>{{ 'NAMEUPDATE.CONFIRMATION.TITLE' | translate }}</h2>
              <div class="message-box success">
                {{ 'NAMEUPDATE.CONFIRMATION.DESCRIPTION' | translate }}
              </div>
              <br />
              <p>
                <span>
                  {{ 'NAMEUPDATE.CONFIRMATION.NEWUSERNAME' | translate }}
                </span>
              </p>
              <p class="accountname">
                <strong> {{ userAccountname }} </strong>
              </p>
              <p>
                <span>
                  {{ 'NAMEUPDATE.CONFIRMATION.NEWEMAIL' | translate }}
                </span>
              </p>
              <p class="accountname">
                <strong> {{ userAccountname + '@edu.vs.ch' }} </strong>
              </p>
              <p>
                <span>
                  {{ 'NAMEUPDATE.CONFIRMATION.EMAILCONFIRM' | translate }}
                  {{ selectedUser.email }}
                </span>
              </p>
              <span>
                {{ 'NAMEUPDATE.CONFIRMATION.DISCONNECT' | translate }}
                {{ timeLeft }}
                {{ 'NAMEUPDATE.CONFIRMATION.SECONDES' | translate }}
              </span>
              <div class="logout-user">
                <button
                  class="logout"
                  mat-raised-button
                  color="warn"
                  (click)="logout()">
                  <mat-icon class="logout-icon">exit_to_app</mat-icon>
                  <span>Logout</span>
                </button>
              </div>
            </mat-card>
          }
          @if (canChangeNameStd) {
            <mat-card class="security-card">
              <h2>{{ 'NAMEUPDATE.CONFIRMATION.TITLE' | translate }}</h2>
              <div class="message-box success">
                {{ 'NAMEUPDATE.CONFIRMATION.DESCRIPTION' | translate }}
              </div>
              <br />
              <p>
                <span>
                  {{ 'NAMEUPDATE.CONFIRMATION.NEWUSERNAME' | translate }}
                </span>
              </p>
              <p class="accountname">
                <strong> {{ userAccountname }} </strong>
              </p>
              <p>
                <span>
                  {{ 'NAMEUPDATE.CONFIRMATION.NEWEMAIL' | translate }}
                </span>
              </p>
              <p class="accountname">
                <strong> {{ userAccountname + '@edu.vs.ch' }} </strong>
              </p>
              <span>
                {{ 'NAMEUPDATE.CONFIRMATION.DISCONNECT' | translate }}
                {{ timeLeft }}
                {{ 'NAMEUPDATE.CONFIRMATION.SECONDES' | translate }}
              </span>
              <div class="logout-user">
                <button
                  class="logout"
                  mat-raised-button
                  color="warn"
                  (click)="logout()">
                  <mat-icon class="logout-icon">exit_to_app</mat-icon>
                  <span>Logout</span>
                </button>
              </div>
            </mat-card>
          }
        </div>
      </div>
    }
  </div>
</div>
